import { useQuery } from '@tanstack/react-query';
import { notificationCenterApi } from '../api/notificationCenterApi';

/**
 * GET /api/eraf/notification-center/history/{id} — 발송 이력 상세
 * queryKey: ['notification-center', 'detail', id]
 */
export function useNotificationDetail(id: number | null) {
  return useQuery({
    queryKey: ['notification-center', 'detail', id],
    queryFn: () => notificationCenterApi.getHistory(id!),
    enabled: id !== null,
    staleTime: 60_000,
  });
}
